export default __webpack_public_path__ + "static/media/coronaImage.68c45462.png";